import { DRSCUSTOMER_SERVICE_URL } from '../../libs/constants';
import { saveAs } from 'file-saver';

//POST
export const getBulkUploadList = (requestData, userId) => async (dispatch, getState, api) => {
    dispatch(setListRefreshed(false));
    await api.post(DRSCUSTOMER_SERVICE_URL + "/bulkUploadPO/list/" + userId, requestData)
    .then(response => {
        if (response.data.bulkUploadedPOFilesList) {
            dispatch({
                type: "SET_PO_BULK_UPLOAD_LIST",
                payload: response.data
            });
        }
        else {
            dispatch(setAPIFetchError(true));     
            dispatch(setListRefreshed(true));
        }
    })    
    .catch(error => {   
        dispatch(setAPIFetchError(true));     
        dispatch(setListRefreshed(true));
    });
};

export const uploadFile = (requestData, userId ) => async (dispatch, getState, api) => {
    dispatch(setBulkUploadInProgress());
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    
    await api.post(DRSCUSTOMER_SERVICE_URL + '/bulkUploadPO/' + userId, requestData, config)
    .then(response => {
        if (response.data.toLowerCase().indexOf("success") !== -1) {
            dispatch(setBulkUploadComplete());
        }
        else {
            dispatch(setBulkUploadError());
        }
    })
    .catch(error => {   
        dispatch(setBulkUploadError());
    });
}

//POST 
const downloadTemplate = (type, userId) => async (dispatch, getState, api) => {
    setBulkUploadTemplateDownloadError(false);
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob" 
    };

    await api.post(DRSCUSTOMER_SERVICE_URL + "/bulkUploadPO/download/" + userId, null, downloadConfig)
    .then(response => {
        saveAs(new Blob([response.data]),  "customer_pobulkupload_template.xlsx");
        dispatch(setBulkUploadTemplateDownloadError(false));
    })
    .catch(error => {
        dispatch(setBulkUploadTemplateDownloadError(true));
        // don't show error message in popup as pop up is already open for bulk upload
    });
};

const setListRefreshed = isRefreshed => {
    return {
        type: 'SET_PO_LIST_REFRESHED',
        data: isRefreshed
    }
}

const setAPIFetchError = isError => {
    return {
        type: 'SET_PO_API_FETCH_ERROR',
        data: isError
    }
}

const setBulkUploadInProgress = () => {
    return {
        type: 'SET_PO_BULK_UPLOAD_IN_PROGRESS'
    }
}

const setBulkUploadComplete = () => {
    return {
        type: 'SET_PO_BULK_UPLOAD_COMPLETE'
    }
}

const setBulkUploadError = () => {
    return {
        type: 'SET_PO_BULK_UPLOAD_ERROR'
    }
}

const setBulkUploadTemplateDownloadError = isError => {
    return {
        type: 'SET_PO_BULK_UPLOAD_TEMPLATE_DOWNLOAD_ERROR',
        data: isError
    }
}

const resetBulkUploadTask = () => {
    return {
        type: 'RESET_PO_BULK_UPLOAD_TASK'
    }
}

const bulkUploadActions = {
    getBulkUploadList, 
    setListRefreshed, 
    setAPIFetchError, 
    uploadFile,
    downloadTemplate,
    setBulkUploadComplete,
    setBulkUploadError,
    setBulkUploadTemplateDownloadError,
    resetBulkUploadTask,
    setBulkUploadInProgress
}

export default bulkUploadActions;